// deps
import React, { ReactNode } from "react";

// internal-deps
import { DeliveryAddressText, OrderConfirmSubText, TICK_STATES } from "@swiggy-private/payment-ui";
import { DeliveryAddress } from "@swiggy-private/payment-types";
import { isEmpty } from "@swiggy-private/js-utils";

interface SubTextNodeListParams {
    state: TICK_STATES;
    subText: string;
    deliveryAddress?: DeliveryAddress;
    getSuperMessageCb: () =>
        | {
              successMessage: string;
              successMessageInfo: string;
          }
        | undefined;
    className?: string;
}

export const getSubTextNode = (
    state: TICK_STATES,
    subText: string,
    getSuperMessageCb: SubTextNodeListParams["getSuperMessageCb"],
    className?: string,
): ReactNode => {
    const superMessage = state === TICK_STATES.SUCCESS ? getSuperMessageCb() : undefined;

    return <OrderConfirmSubText superMessage={superMessage} subtext={subText} className={className} />;
};

export const getDeliveryTextNode = (state: TICK_STATES, deliveryAddress?: DeliveryAddress): ReactNode | null => {
    if (state !== TICK_STATES.SUCCESS || isEmpty(deliveryAddress)) {
        return null;
    }
    return <DeliveryAddressText deliveryAddress={deliveryAddress} />;
};

export const getSubTextNodeList = ({
    state,
    subText,
    deliveryAddress,
    getSuperMessageCb,
    className,
}: SubTextNodeListParams): ReactNode[] => {
    const subTextList = [getSubTextNode(state, subText, getSuperMessageCb, className)];
    const deliveryTextNode = getDeliveryTextNode(state, deliveryAddress);

    if (!isEmpty(deliveryTextNode)) {
        subTextList.push(deliveryTextNode);
    }
    return subTextList;
};
